import React from "react";
import { Wrapper } from "@gw/component-library";
import { BaseLayout } from "../../layouts";
import { NotFound } from "../../components";
var NotFoundPage = function () {
    return (React.createElement(BaseLayout, null,
        React.createElement(Wrapper, null,
            React.createElement(NotFound, null))));
};
export default NotFoundPage;
//# sourceMappingURL=NotFoundPage.js.map